module.exports = __webpack_public_path__ + "static/media/mail.7ed463be.svg";